import type { EmblaCarouselType } from 'embla-carousel'

export const setupProgressBar = (
    emblaApi: EmblaCarouselType,
    progressNode: HTMLElement
): {
    applyProgress: () => void
    removeProgress: () => void
} => {
    const applyProgress = (): void => {
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()))
        const progressPercentage = (progress * 100).toFixed(2)
        progressNode.style.transform = `translate3d(${progressPercentage}%,0px,0px)`
    }

    const removeProgress = (): void => {
        progressNode.removeAttribute('style')
    }

    return {
        applyProgress,
        removeProgress
    }
}
